export default "__VITE_ASSET__Cl7Jvs7T__"